import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { ListBase } from 'src/app/components/core/_infrastructure/classes/listBase';
import { Table } from 'primeng/table';
import { FilterSearchingBaseViewModel } from 'src/app/components/core/_infrastructure/types/common';
import { EnumCodigosTwTcAcciones } from 'src/app/components/_importacion/solicitudes/types/enum';
import {
    FilterSearchingRecintoUnidadInspeccion,
    RecintoUnidadInspeccionItemResultsViewModel,
    RecintoUnidadInspeccionItemViewModel,
} from '../buscador-unidad-inspeccion.types';
import { UserDataViewModel } from '../../solicitudes/buscador-solicitud-cam.types';
import { EnumDescripcionTcTipoSolicitudCamSingular, EnumIdsTcTipoSolicitudCam, EnumTcEstadoUnidadInspeccion } from '../../../types/enum';

@Component({
    selector: 'app-buscador-unidad-inspeccion-list',
    templateUrl: './buscador-unidad-inspeccion-list.component.html',
})
export class BuscadorUnidadInspeccionListComponent extends ListBase implements OnInit, OnChanges {
    @Input() result: RecintoUnidadInspeccionItemResultsViewModel;
    @Input() lastFilter: FilterSearchingRecintoUnidadInspeccion;
    @Input() userData: UserDataViewModel;
    @Output() search = new EventEmitter<FilterSearchingBaseViewModel>();
    @Output() edit = new EventEmitter<number | null>();
    @Output() view = new EventEmitter<RecintoUnidadInspeccionItemViewModel>();

    @ViewChild('tableSearch') turboTable: Table;

    cols: any[];

    ID_TIPO_PARCELA = EnumIdsTcTipoSolicitudCam.ID_PARCELA;
    ID_TIPO_INVERNADERO = EnumIdsTcTipoSolicitudCam.ID_INVERNADERO;
    ID_TIPO_ALMACEN = EnumIdsTcTipoSolicitudCam.ID_CONFECCION;
    ID_TIPO_EMP_DESHIDRATADORA = EnumIdsTcTipoSolicitudCam.ID_EMPRESA_DESHIDRATACION;
    SIN_ASIGNAR = EnumTcEstadoUnidadInspeccion.SIN_ASIGNAR;

    constructor(protected notificacionService: NotificationService) {
        super(notificacionService);
    }

    ngOnInit() {
        this.initCols();
        this.loading = false;
    }

    private initCols(): void {
        this.cols = [
            { field: 'ExpandLink', header: '', reduce: true },
            { field: 'Link', header: '', reduce: true },
            { field: 'Image', header: '', reduce: true },
            { field: 'IdUi', header: 'Id', display: 'none' },
            { field: 'FechaCreacion', header: 'F. Creación' },
            { field: 'CodigoUhc', header: 'Cod. Ud. Insp.' },
            { field: 'Campania', header: 'Campaña' },
            { field: 'Periodo', header: 'Periodo' },
            { field: 'TipoSolicitud', header: 'Tipo Recinto' },
            { field: 'DescripcionComunidad', header: 'Com. Aut.' },
            { field: 'EntidadAuditora', header: 'Entidad Auditora' },
        ];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.result?.currentValue) {
            this.result = { ...changes.result.currentValue };
            this.loading = false;
            setTimeout(() => {
                if (this.turboTable) {
                    this.turboTable.sortOrder = this.lastFilter?.Asc;
                    this.turboTable.sortField = this.lastFilter?.OrderBy;
                    this.turboTable.first = this.lastFilter?.PageNumber * this.result?.PageSize;
                }
            }, 100);
        }
    }

    onSearchLazy(event: any): void {
        if (!event.rows || event.sortField == 'Link' || event.sortField == 'Image') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.loading = true;

        const f: FilterSearchingBaseViewModel = {
            PageNumber: pageNumber,
            Asc: event.sortOrder,
            OrderBy: event.sortField || '',
        };

        this.search.emit(f);
    }

    onEdit(item: RecintoUnidadInspeccionItemViewModel): void {
        this.edit.emit(item?.IdUi);
    }

    onView(item: RecintoUnidadInspeccionItemViewModel): void {
        this.view.emit(item);
    }

    /**
     * Este método indica si se puede editar la UI.
     * Se podrá editar por el usuario propietario o el admin, siempre que estén en un estado permitido.
     * @param item UnidadInspeccionItemViewModel
     * @return boolean
     */
    hasWriteAccess(item: RecintoUnidadInspeccionItemViewModel): boolean {
        if (!item.PeriodoEnPlazoVigente) {
            return false;
        }
        const hasAccess = this.userData?.loggedInUser?.getAction(EnumCodigosTwTcAcciones.EDIT_UD_INSPECCION, item.IdEstadoUi).Editable || false;
        return hasAccess;
    }

    /***
     * Este método indica si se puede visualizar la UI.
     * @param item UnidadInspeccionItemViewModel
     * @return boolean
     */
    hasViewAccess(item: RecintoUnidadInspeccionItemViewModel): boolean {
        const hasAccess = this.userData?.loggedInUser?.getAction(EnumCodigosTwTcAcciones.VIEW_UD_INSPECCION, item.IdEstadoUi).Visible || false;
        return hasAccess;
    }

    title(idTipoSolicitudCam: number): string {
        switch (idTipoSolicitudCam) {
            case EnumIdsTcTipoSolicitudCam.ID_CONFECCION:
                return EnumDescripcionTcTipoSolicitudCamSingular.CONFECCION;
            case EnumIdsTcTipoSolicitudCam.ID_EMPRESA_DESHIDRATACION:
                return EnumDescripcionTcTipoSolicitudCamSingular.EMPRESA_DESHIDRATACION;
            case EnumIdsTcTipoSolicitudCam.ID_PARCELA:
                return EnumDescripcionTcTipoSolicitudCamSingular.PARCELA;
            case EnumIdsTcTipoSolicitudCam.ID_INVERNADERO:
                return EnumDescripcionTcTipoSolicitudCamSingular.INVERNADERO;
            default:
                return EnumDescripcionTcTipoSolicitudCamSingular.RECINTO;
        }
    }
}
